import { RG_TYPE as o, isPolygonClosed as a } from "@project-rouge/rg-core";
import { offsetPolygon as f } from "../clipper-utils/index5.js";
import { getLevelBoundary as p } from "../../3d/boundary/index6.js";
import { getBuildingBoundary as c } from "../../3d/boundary/index5.js";
function g(t, r, i) {
  let n = 0;
  t.children.find((l) => l.type === o.Apartment) && (n = i.externalModuleWallThickness);
  let e;
  return r.isPodium ? e = c(t, [r.levelIndex], [o.EmptySpace, o.Entrance, o.Core, o.Corridor, o.TechnicalSpace]) : e = p(t, r), e.length === 0 ? [] : (n > 0 && (e = f(e, -n)), e = a(e) ? e : e.concat([e[0]]), e);
}
export {
  g as getLevelGIAPolygon
};
//# sourceMappingURL=index.js.map
